import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import ActionIconButton from '../common/ActionIconButton';

const EditButton = ({ onEdit, item }) => {
    return (
        <ActionIconButton
            title="Edit"
            onClick={() => onEdit(item)}
            icon={<EditIcon fontSize="small" />}
        />
    );
};

export default EditButton;
